export default {
    videoName: "The Holy Road",
    videos: {
        id: "VideoNL",
        mobile: {
            src: "https://output.scrollytelling.io/theholyroad/videos/the-holy-road_web.mp4",
            type: "video/mp4"
        },
        desktop: {
            src: "https://output.scrollytelling.io/theholyroad/videos/De_WegTOTAAL_AUDIO_8MEI_PICTURELOCK_CC_titelloos__AUDIO_1_kleur_(RES_1280_22).mp4",
            type: "video/mp4"
        },
        dash: {
          src: "https://output.scrollytelling.io/v1/main/pageflow/video_files/000/002/320/dash/manifest.mpd",
          type: "application/dash+xml"
        },
        hls: {
          src: "https://output.scrollytelling.io/v1/main/pageflow/video_files/000/002/320/hls-fullhd.m3u8",
          type: "application/x-mpegURL"
        }
    },
    introText: "The Holy Road is een interactieve webdocumentaire over de mensen die leven aan de ‘heiligste’, maar ook meest beladen weg door Israel en Palestina: Route 60.",
    startRoute: "Start route",
    rijVerder: "Rij verder",
    terugNaarRoadMovie: "TERUG NAAR ROADMOVIE"
}



// WEBPACK FOOTER //
// ./src/data/nl/video.js